module.exports = __webpack_public_path__ + "img/08.fb3b93f4.jpg";